import { render } from "./CandlesCarousel.vue?vue&type=template&id=d28d1ce8&scoped=true&lang=html"
import script from "./CandlesCarousel.vue?vue&type=script&lang=js"
export * from "./CandlesCarousel.vue?vue&type=script&lang=js"

import "./CandlesCarousel.vue?vue&type=style&index=0&id=d28d1ce8&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d28d1ce8"]])

export default __exports__